import { Button } from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from 'types/RequestStatus';
import { DeleteButtonTooltipContent } from './DeleteButtonTooltipContent';
import { ConfirmationModal } from 'components/common/ConfirmationModal/ConfirmationModal';
import { useNavigate } from 'react-router-dom';
import useSubmit, { POST } from 'hooks/useSubmit';
import { useState } from 'react';
import { COMPANIES_DELETE_COMPANY } from 'apiRoutes';
import { Company } from 'domain/company/Company';
import { ConditionallyDisabled } from 'components/common/ConditionallyDisabled/ConditionallyDisabled';

export const DeleteCompanyAction: React.FC<{
	hasUsers: boolean;
	hasSubscriptions: boolean;
	company: Company;
}> = ({ hasUsers, hasSubscriptions, company }) => {
	const navigate = useNavigate();

	const [deleteCompany, deleteCompanyStatus] = useSubmit(
		COMPANIES_DELETE_COMPANY,
		POST,
		{
			messageOnSuccess: 'Company successfully deleted.',
			messageOnError: 'An error occured, please try again.',
			showApiError: true,
		},
	);

	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const canDeleteCompany = !hasUsers && !hasSubscriptions;

	return (
		<>
			<ConditionallyDisabled
				disableIf={!canDeleteCompany}
				tooltip={
					<DeleteButtonTooltipContent
						hasUsers={hasUsers}
						hasSubscriptions={hasSubscriptions}
					/>
				}
			>
				<Button
					variant="negative"
					text="Delete company"
					isLoading={status === RequestStatus.LOADING}
					onClick={() => setShowConfirmationModal(true)}
				/>
			</ConditionallyDisabled>
			<ConfirmationModal
				showModal={showConfirmationModal}
				setShowModal={setShowConfirmationModal}
				onSubmit={async (comment) => {
					const result = await deleteCompany({
						companyId: company.id,
						comment: comment,
					});

					if (result.success) {
						navigate('/companies');
					}
				}}
				header={'Delete company'}
				text={`Are you sure you want to delete ${company.name}?`}
				buttonText={'Delete'}
				loadingStatus={deleteCompanyStatus}
				loadingText="Deleting..."
			/>
		</>
	);
};
